<div class="content">
  <div class="component-header">
    <h1 class="highlight-line">{{ title() }}</h1>
  </div>
  <div [innerHTML]="legalHtmlNoticeContent()" class="legal-notice"></div>
</div>
